import React from "react"

const DeveloperTeam = () =>
(
    <div>
        <div class="container-ge flex-ge bg-ge">
            <div class="flex2-ge content-ge">
                <div class="developer-name-ge">
                    Alen Babayiğit
                </div>
                <div class="content-ge">
                    <p>
                        Ben Alen Babayiğit. 14 Mart 2001'de Antalya'da doğdum. Ege Üniversitesinde Bilgisayar Mühendisliği okuyorum. Bu bölümü okurken kendimi geliştirmem gerektiğini düşündüm ve kendimi IEEE Ege Öğrenci Topluluğu'nda buldum. Bir dönem Computer Society üyesi olduktan sonra Computer Society başkanlığı görevini üstlendim. Başkanlık yaptığım 21-22 döneminde 2 Tea Talk, IEEE Ege EA ortaklığıyla Hour of Code etkinliği ve yepyeni bir sosyal etkinlik olan Access IT'ye imza attık.
                        <br />
                        <br />
                        Başkanlık yaptığım dönemde komitemizde teknik ekipler kuruldu. Şu anda IEEE Ege Computer Society bünyesinde devam etmekte olan Fullstack Web, Data Science ve Mobil ekiplerine ek ilk açılan Frontend ve Backend ekiplerimizden kalan arkadaşlarımla oluşturduğumuz Web Geliştirici ekibimiz ile çalışmalarımıza devam ediyoruz. Bu sitenin yapımında ekip lideri ve React Developer olarak görev aldım. Ekibime bu siteyi geliştirme yolunda beni yalnız bırakmadıkları için çok teşekkür ederim :)
                    </p>
                </div>
            </div>
            <div class="flex1-ge">
                <div>
                    <img class="img-ge" src={require("../components/images/developers/alenbabayigit.jpg")} alt="Alen" />
                </div>
            </div>
        </div>
        {/*
        <div class="container-ge flex-ge bg-ge">
            <div class="flex1-ge">
                <div>
                    <img class="img-ge" src="https://picsum.photos/300/300" alt="" />
                </div>
            </div>
            <div class="flex2-ge content-ge">
                <div class="developer-name-ge">
                    Barış Mutlu
                </div>
                <div class="content-ge">
                    <p>
                        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Temporibus aliquid, reiciendis dolores at eius exercitationem voluptatibus eligendi qui, doloremque eveniet fuga ullam nemo perspiciatis quibusdam sint enim sunt impedit porro molestiae odit nam dolorem tempora. Placeat omnis quisquam, recusandae odio maxime soluta consequatur magni eligendi sit necessitatibus adipisci officiis enim!
                    </p>
                </div>
            </div>
        </div>
        */}
        {/*
        <div class="container-ge flex-ge bg-ge">
            <div class="flex2-ge content-ge">
                <div class="developer-name-ge">
                    Bora Eroğlu
                </div>
                <div class="content-ge">
                    <p>
                        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Temporibus aliquid, reiciendis dolores at eius exercitationem voluptatibus eligendi qui, doloremque eveniet fuga ullam nemo perspiciatis quibusdam sint enim sunt impedit porro molestiae odit nam dolorem tempora. Placeat omnis quisquam, recusandae odio maxime soluta consequatur magni eligendi sit necessitatibus adipisci officiis enim!
                    </p>
                </div>
            </div>
            <div class="flex1-ge">
                <div>
                    <img class="img-ge" src="https://picsum.photos/300/300" alt="" />
                </div>
            </div>
        </div>
        */}
        <div class="container-ge flex-ge bg-ge">
            <div class="flex1-ge">
                <div>
                    <img class="img-ge" src="https://picsum.photos/300/300" alt="" />
                </div>
            </div>
            <div class="flex2-ge content-ge">
                <div class="developer-name-ge">
                    Emirhan Güleroğlu
                </div>
                <div class="content-ge">
                    <p>
                        Merhaba ben Emirhan Güleroğlu, 17 Haziran 2002 yılında Avusturya'da doğdum. Ege Üniversitesi Fizik bölümünde okuyorum. Ayrıca kendimi geliştimek adına yazılıma atıldım ve şu anda Front-end ile ilgileniyor bulunmaktayım. Proje kısmında da genel olarak JavaScript ve React.js kodu yazma bölümünde bulundum. Bu proje hepimize çok büyük şey kattı ve bu deneyimi yaşadığım için IEEE Ege Computer Society'ye çok teşekkür ederim.
                    </p>
                </div>
            </div>
        </div>
        {/*
        <div class="container-ge flex-ge bg-ge">
            <div class="flex2-ge content-ge">
                <div class="developer-name-ge">
                    Erhan Namlı
                </div>
                <div class="content-ge">
                    <p>
                        Lorem, ipsum dolor sit amet consectetur adipisicing elit. Temporibus aliquid, reiciendis dolores at eius exercitationem voluptatibus eligendi qui, doloremque eveniet fuga ullam nemo perspiciatis quibusdam sint enim sunt impedit porro molestiae odit nam dolorem tempora. Placeat omnis quisquam, recusandae odio maxime soluta consequatur magni eligendi sit necessitatibus adipisci officiis enim!
                    </p>
                </div>
            </div>
            <div class="flex1-ge">
                <div>
                    <img class="img-ge" src="https://picsum.photos/300/300" alt="" />
                </div>
            </div>
        </div>
        */}

        <div class="container-ge flex-ge bg-ge">
            <div class="flex1-ge">
                <div>
                    <img class="img-ge" src={require("../components/images/developers/gizemduygusonmez.jpg")} alt="Gizem" />
                </div>
            </div>
            <div class="flex2-ge content-ge">
                <div class="developer-name-ge">
                    Gizem Duygu Sönmez
                </div>
                <div class="content-ge">
                    <p>
                        Ben Ege Üniversitesi Bilgisayar Mühendisliği öğrencilerinden Gizem Duygu Sönmez. 26 Şubat 2002'de Kocaeli Gebze'de doğdum. 1. Sınıfdayken kendimi geliştirmek amacıyla katıldığım IEEE Ege Computer Society'nin Backend ve Frontend ekiplerinin aktif bir üyesiyim. Birlikte teknik alanlarda kendimizi geliştirmenin yanı sıra Access IT, Hour of Code, Tea Talk gibi sosyal etkinlikler gerçekleştirdiğimiz IEEE Ege Computer Society ailesinde olmaktan mutluluk duyuyorum. Bu proje içerisinde React.js, Javascript ve gerektiği zamanlarda CSS kısımlarında görevler aldım. IEEE Ege web sitesini başarıyla gerçekleştirdiğimiz, geliştirirken beraber öğrendiğimiz ekibime teşekkür ederim :)
                    </p>
                </div>
            </div>
        </div>

        <div class="container-ge flex-ge bg-ge">
            <div class="flex2-ge content-ge">
                <div class="developer-name-ge typewriter">
                    Özgür Bayraşa
                </div>
                <div class="content-ge">
                    <p>
                        Merhabalar, ben Özgür Bayraşa. Ege Üniversitesi Bilgisayar Mühendisliği öğrencisiyim. 19 Nisan 2001'de İstanbul'da doğdum. IEEE Ege Örenci Topluluğuna 2020 yılında dahil oldum. Bir dönem EdSoc üyesi olarak katkı verdikten sonra Computer Society'e geçtim. Computer Society içerisinde Access IT gibi, sektörden konuşmacıların katıldığı etkinliklerde moderatör olmanın yanı sıra çeşitli teknik ekiplerde frontend alanında eğitimler verdim. Aynı zamanda Tea Talk tarzı sosyal etkinliklerle ekip içerisinde birbirinden değerli arkadaşlar edindim.
                        <br />
                        <br />
                        IEEE Ege Web Sitesi içerisinde CSS konusunda katkı sağladım. Web alanında kendi adıma çalıştığım ilk proje olması açısından bu web sitesinin bende yeri çok özel. Web alanında, durmadan kendimi geliştirmeye devam etmek ve kariyerime FullStack Developer olarak devam etmek istiyorun.
                    </p>
                </div>
            </div>
            <div class="flex1-ge">
                <div>
                    <img class="img-ge" src={require("../components/images/developers/ozgurbayrasa.jpg")} alt="Ozgur" />
                </div>
            </div>
        </div>

        <div class="container-ge flex-ge bg-ge">
            <div class="flex1-ge">
                <div>
                    <img class="img-ge" src={require("../components/images/developers/serapaltunbulak.jpg")} alt="Serap" />
                </div>
            </div>
            <div class="flex2-ge content-ge">
                <div class="developer-name-ge">
                    Serap Altunbulak
                </div>
                <div class="content-ge">
                    <p>
                        Selamlar, ben Serap Altunbulak. Ege Üniversitesi Bilgisayar Mühendisliği 3. sınıf öğrencisiyim. 2001 İstanbul doğumluyum. IEEE Ege Öğrenci Topluluğuna 2021 Ocak&#39;ta katıldım. Computer Society&#39;de görev almaktayım. Computer Society&#39;de CyberEge21&#39;de görev aldım; Data Science ekibine liderlik ettim ve Front-end ekibinde yer aldım ama en önemlisi de bu güzel ortamda bulunma şansı elde ettim:) Tüm ekip arkadaşlarıma teşekkürler;)
                    </p>
                </div>
            </div>
        </div>

    </div>
)

export default DeveloperTeam;